export const displayFont = 'Syne, sans-serif'
export const bodyFont = 'Newsreader, serif'

export function loadWebFonts() {
  if (typeof document === 'undefined') return
  if (document.getElementById('ivyooo-fonts')) return
  const link = document.createElement('link')
  link.id = 'ivyooo-fonts'
  link.rel = 'stylesheet'
  link.href = 'https://fonts.googleapis.com/css2?family=Newsreader:opsz,wght@6..72,400;6..72,600&family=Syne:wght@500;600;700&display=swap'
  document.head.appendChild(link)
}
